import { useState } from "react";
import { cn } from "@/lib/utils";
import { NotificationTabsProps } from "./types";

export function NotificationTabs({
  activeCategory,
  onCategoryChange,
  apps,
}: NotificationTabsProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  // Create categories from apps with 'all' as first
  const allCategories = [
    { value: "all", label: "All" },
    ...apps.map((app) => ({ value: app.name.toLowerCase(), label: app.name })),
  ];

  // Show first 3 tabs (All + 2 apps), rest go into +x
  const visibleTabs = isExpanded ? allCategories : allCategories.slice(0, 3);
  const hiddenCount = allCategories.length - 3;

  return (
    <div className="aero:bg-neutral-50 aero:rounded-lg aero:p-2 aero:flex aero:flex-wrap aero:gap-2 aero:min-h-12 aero:items-start">
      {visibleTabs.map((category) => (
        <button
          key={category.value}
          onClick={() => onCategoryChange(category.value)}
          className={cn(
            "aero:h-8 aero:px-6 aero:py-3 aero:rounded-lg",
            "aero:flex aero:items-center aero:justify-center",
            "aero:text-sm aero:leading-5 aero:text-center aero:whitespace-nowrap",
            "aero:transition-all aero:cursor-pointer",
            activeCategory === category.value
              ? "aero:bg-blue-100 aero:font-bold aero:text-blue-800 aero:shadow-[0px_1px_3px_0px_rgba(16,24,40,0.1),0px_1px_2px_0px_rgba(16,24,40,0.06)]"
              : "aero:bg-transparent aero:font-normal aero:text-[#667085] aero:hover:text-neutral-700"
          )}
        >
          {category.label}
        </button>
      ))}

      {!isExpanded && hiddenCount > 0 && (
        <button
          onClick={() => setIsExpanded(true)}
          className={cn(
            "aero:h-8 aero:px-6 aero:py-3 aero:rounded-lg",
            "aero:flex aero:items-center aero:justify-center",
            "aero:text-sm aero:leading-5 aero:text-center",
            "aero:transition-all aero:cursor-pointer",
            "aero:bg-transparent aero:font-normal aero:text-[#667085] aero:hover:text-neutral-700"
          )}
          title="Show all"
        >
          +{hiddenCount}
        </button>
      )}
    </div>
  );
}
